import { BanknotesIcon, BuildingOfficeIcon, CreditCardIcon } from '@heroicons/vue/24/outline'

/**
 * Icon mapping utility for consistent icon resolution across components
 */
const iconMap = {
    'banknotes-icon': BanknotesIcon,
    'credit-card-icon': CreditCardIcon,
    'building-office-icon': BuildingOfficeIcon,
}

/**
 * Get icon component by string identifier
 * @param {string} iconName - The icon identifier string
 * @returns {Component|null} Vue component or null if not found
 */
export function getIcon(iconName) {
    return iconMap[iconName] || null
}

/**
 * Add new icon mapping (useful for dynamic icon registration)
 * @param {string} iconName - The icon identifier string
 * @param {Component} iconComponent - Vue icon component
 */
export function registerIcon(iconName, iconComponent) {
    iconMap[iconName] = iconComponent
}

/**
 * Get all available icon names
 * @returns {string[]} Array of available icon identifiers
 */
export function getAvailableIcons() {
    return Object.keys(iconMap)
}

export default {
    getIcon,
    registerIcon,
    getAvailableIcons,
}
